module.exports = __webpack_public_path__ + "media/images/emblems/Wolfenschiessen-coat_of_arms-4376d1ce5f2f450141c154000fc62cfd.svg";